var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_117_557",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.329 0C191.641 0 200 8.35934 200 18.6709C200 28.9824 191.641 37.3418 181.329 37.3418H107.427L100.781 50L94.1357 37.3418H18.6709C8.35939 37.3418 8.96855e-05 28.9824 0 18.6709C0 8.35934 8.35934 0 18.6709 0H181.329Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 18.6709L202 18.6709V18.6709H200ZM107.427 37.3418V35.3418H106.218L105.656 36.4121L107.427 37.3418ZM100.781 50L99.0105 50.9297L100.781 54.3026L102.552 50.9297L100.781 50ZM94.1357 37.3418L95.9065 36.4121L95.3446 35.3418H94.1357V37.3418ZM0 18.6709H-2V18.6709L0 18.6709ZM181.329 0V2C190.536 2 198 9.46391 198 18.6709H200H202C202 7.25477 192.745 -2 181.329 -2V0ZM200 18.6709L198 18.6709C198 27.8778 190.536 35.3418 181.329 35.3418V37.3418V39.3418C192.745 39.3418 202 30.0869 202 18.6709L200 18.6709ZM181.329 37.3418V35.3418H107.427V37.3418V39.3418H181.329V37.3418ZM107.427 37.3418L105.656 36.4121L99.0105 49.0703L100.781 50L102.552 50.9297L109.198 38.2715L107.427 37.3418ZM100.781 50L102.552 49.0703L95.9065 36.4121L94.1357 37.3418L92.3649 38.2715L99.0105 50.9297L100.781 50ZM94.1357 37.3418V35.3418H18.6709V37.3418V39.3418H94.1357V37.3418ZM18.6709 37.3418V35.3418C9.46398 35.3418 2.00008 27.8778 2 18.6709L0 18.6709L-2 18.6709C-1.9999 30.0869 7.2548 39.3418 18.6709 39.3418V37.3418ZM0 18.6709H2C2 9.46391 9.46391 2 18.6709 2V0V-2C7.25477 -2 -2 7.25477 -2 18.6709H0ZM18.6709 0V2H181.329V0V-2H18.6709V0Z",
    fill: "#DA2538",
    mask: "url(#path-1-inside-1_117_557)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.70fdf9feed965bd3775c71ab89ef072e.svg";
export { ForwardRef as ReactComponent };